import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import imgTemp from "../../assets/landers_temp1.jpeg";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "온라인 예매 방법",
    content:
      "티켓 예매는 랜더스 APP, 티켓링크 APP/홈페이지에서 가능합니다. \n\n [예매 가능 시간] \n[ICON:check]일반 예매 : 경기 4일 전 오전 11시~ \n[ICON:check]멤버십 선예매 \n- FRONTIER, LEGEND, ALLSTAR 회원 \n[SPACE]: 경기 7일 전 오전 11시~\n- REGULAR 회원 \n[SPACE]: 경기 6일 전 오전 11시~\n- ROOKIE 회원 \n[SPACE]: 경기 5일 전 오전 11시~\n\n※ 멤버십 선예매는 랜더스 APP을 통해서만 이용 가능합니다.\n※ 예매는 1회 6매 가능합니다. (최대 2회 가능)\n[SPACE]*다인석의 경우 좌석 수에 맞춰 예매 가능",
    reference: "",
    buttons: [
      { 
        title: "랜더스 APP 바로가기",
        link: ""
      },
      { 
        title: "티켓링크 바로가기",
        link: ""
      }
    ]
  },
  {
    title: "현장 예매 방법",
    content:
      "현장 예매는 온라인 예매 잔여 좌석 및 스포츠 관람권 보장을 위한 현장 판매분만 이용 가능합니다. \n\n [ICON:check]현장 판매 제도 \n - 경기 : 정규 시즌 홈경기\n  - 대상 : 디지털 취약 계층을 포함한 전 고객 \n - 좌석 : 4층 SKY뷰석 413블록 150매 \n[SPACE]*1인 1매 한정 구매 가능\n - 가격 : 기존 좌석 요금과 동일 \n- 구매처 : 1루 매표소 내 전용 창구 \n- 운영시간 \nㆍ주중 경기 : 경기 시작 2시간 30분 전 \nㆍ주말 경기 : 경기 시작 3시간 전 \n[SPACE]*매표소 운영 시간과 동일 \n\n ※ 배정 좌석이 전량 소진될 경우 판매가 조기 마감될 수 있습니다.",
    reference: "",
  },
  {
    title: "티켓 가격",
    content:
      "",
    reference:
      "",
  },
  {
    title: "티켓 취소/환불",
    content:
      "예매 취소는 경기 시작 4시간 전까지만 가능합니다. \n\n [ICON:check]취소 수수료 \n - 티켓 결제 당일 : 취소 수수료 없음 \n- 경기 당일 : 예매 금액의 10% 수수료 부과  \n[SPACE]*경기 시작 4시간 전까지 가능 \n\n [ICON:check]경기 취소 시 (우천 취소 등) \n- 카드 결제 : 일괄 결제 취소 처리 \n- 무통장입금 : 예매처에 등록된 환불 계좌로 입금 \n- 현장 구매 : 매표소 방문 및 티켓 반환 후 환불 접수 \n\n※ 티켓 취소 후 환불은 카드사에 따라 영업일 기준 3~5일 정도 소요될 수 있습니다. \n※ 티켓 관련 자세한 사항은 티켓링크 고객센터(1588-7890)로 문의 부탁드립니다.",
    reference: "",
  },
  {
    title: "티켓 발권",
    content:
      "[ICON:check]스마트 티켓 (랜더스 APP, 티켓링크 APP) \n - 지류 티켓 발권 없이 게이트에서 스마트티켓 검표 후 바로 입장 가능합니다. \n- 스마트 티켓은 경기 시작 4시간 전부터 APP을 통해 발권 가능합니다. \n\n ※ 스마트티켓 발권 시 지류 티켓 발권은 불가합니다. \n※ 할인 권종(경로, 어린이 등)은 현장 매표소에서 본인 확인 후 발권 가능합니다. \n[SPACE]*현장 매표소 운영 시간\n[SPACE][SPACE]ㆍ주중 : 경기 시작 2시간 30분 전\n[SPACE][SPACE]ㆍ주말 : 경기 시작 3시간 전",
    reference: "",
  },
  {
    title: "단체관람",
    content:
      "단체관람 제도는 50인 이상의 일반 단체(기업, 동아리 등), 학교 단체(초·중·고교) 대상 일부 좌석에 한 해 운영됩니다. \n\n 단체관람 기준은 SSG랜더스 홈페이지를 참고 부탁드리며, 구매 및 상담은 티켓링크 고객센터(1588-7890)에서 가능합니다.",
    reference: "",
    buttons: [
      { 
        title: "랜더스 홈페이지 바로가기",
        link: "https://www.ssglanders.com/game/group"
      },
      { 
        title: "티켓링크 고객센터",
        link: ""
      }
    ]
  },
  {
    title: "다인석 인원추가",
    content:
      "일부 다인석의 경우 현장 매표소를 통해 관람 인원 추가가 가능합니다. \n\n [ICON:check]가능 좌석 : 내야패밀리존, 외야패밀리존, 오픈바비큐존, 이마트바비큐존, 외야파티덱, 미니 스카이박스, 스카이박스 \n [ICON:check]인원 추가 : 최대 1명 (스카이박스는 최대 2명) \n\n ※ 추가 인원은 현장 매표소를 통해 추가 요금 지불 후 이용 가능합니다. \n※ 별도의 추가 좌석이 제공되지 않는 점 유의 바랍니다. \n※ 가능 좌석 외 일반 좌석은 인원 추가가 불가합니다.",
    reference: "",
  },
  {
    title: "입장시간",
    content:
      "당일 티켓 소지 고객은 게이트에서 검표 후 입장 가능합니다. \n\n [ICON:check]입장시간 \nㆍ주중 : 경기 1시간 30분 전 \nㆍ주말 : 경기 2시간 전 \n\n ※ REGULAR 이상 멤버십 회원은 전용 게이트를 통해 30분 선입장 가능합니다. \n\n [ICON:check]입장 게이트 \nㆍ일반 고객 \n - 1루 방면 : 1번, 3번 게이트 \n- 3루 방면 : 5번, 6번 게이트 \n - 외야 방면 : 7번 게이트 \n\nㆍ멤버십 선입장  \n- FRONTIER 게이트 \n: FRONTIER 회원 전용 \n - LEGEND 게이트   \n: LEGEND 회원 전용  \n - 스타벅스 게이트 \n : REGULAR 이상 회원 전용 \n\n ※ 멤버십 선입장은 전용 게이트를 통해서만 이용 가능합니다. \n※ 멤버십 회원이 예매한 티켓에 한 해 동반인 선입장 가능합니다.",
    reference: "",
  },
  {
    title: "영유아 무료입장",
    content:
      "36개월 미만 영유아는 별도 티켓 구매 없이 보호자 동행 하에 입장 가능합니다. \n\n ※ 반드시 당일 티켓을 소지한 보호자 동행이 필요합니다. \n※ 36개월 미만 생년월일 확인이 가능한 증빙을 지참하여 주시기 바랍니다.\n[SPACE](현장 스태프의 육안 확인이 어려운 경우 증빙 확인 필요) \n※ 별도의 좌석은 제공되지 않습니다. \n※ 파울볼 등 안전사고에 각별히 주의하시기 바랍니다. \n※ 36개월 이상 관람객은 티켓 구매 후 입장 가능합니다.",
    reference: "",
  },
  {
    title: "티켓 권종 변경",
    content:
      "어린이/청소년 할인으로 예매한 티켓은 현장 매표소에서 차액 지불 후 일반 권종으로 변경 가능합니다. \n\n※ 일반 권종 → 어린이/청소년 권종 변경은 불가합니다. \n※ 주니어 멤버십 할인 예매 건은 일반 권종으로 변경 불가합니다.\n※ 어린이/청소년 권종 외 타 할인 권종은 일반 권종 변경이 불가합니다.",
    reference: "",
  },
  {
    title: "휠체어석 이용",
    content:
      "휠체어석은 거동이 불편하여 휠체어를 이용하는 관람객을 위한 좌석입니다. \n\n ※ 휠체어석 예매 시 현장 매표소에서 확인 후 발권 가능합니다. \n[SPACE](스마트티켓 이용 불가) \n※ 보호자(1명)은 현장 매표소를 통해 추가 요금 지불 후 동반 입장 가능합니다. \n[SPACE](휠체어석 옆좌석 이용 가능)",
    reference: "",
  }
];

const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline pt-1">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-start">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
    {({state}) => 
      <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
        <p className="font-medium text-gray-950">
        {
          item.title === "티켓 가격" ? <img src={imgTemp} alt="티켓 가격" /> : 
          formatText(item.content)
        }</p>
        {item.buttons && (
          <div className="flex justify-center flex-col">
            {item.buttons.map(button => (
              <LinkItem
                title={button.title}
                url={button.link}
                styles={"mx-6"}
              />
            ))}
          </div>
        )}
      </div>
    } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);


export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-12 rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const TicketPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="티켓 예매" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950">
        <div>랜더스 APP, 티켓링크 APP/홈페이지를 통해 홈경기 티켓 예매가 가능합니다.</div>
        <div>*온라인 예매 매진 시 현장 판매는 미운영 될 수 있습니다.</div>
        <div>티켓 관련 일반 문의는 티켓링크 고객센터(1588-7890)으로 문의 부탁드립니다.</div>
        <LinkItem
          title="티켓링크 고객센터"
          url="tel:"
          onClick={() => trackButtonClick("티켓예매_티켓링크 고객센터")}
        />
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:02-2045-6877"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("티켓예매_전화상담")}
        />
      </div>
    </section>
  );
};

export default TicketPage;
